import Entity from 'utilities/entity';

class ProjectGroup extends Entity {
    
}

export default new ProjectGroup();